import React from "react";

// PSIEC brand: emblem on a white chip + wordmark. Designed for dark (navy) headers/footers.
export const Logo = ({ size = 44, tagline = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-3.5 ${className}`} data-testid="brand-logo">
      <span
        className="grid place-items-center shrink-0 bg-white rounded-[3px] p-1.5"
        style={{ width: size, height: size }}
      >
        <img
          src="/brand/psiec-emblem.png?v=4"
          alt="PSIEC emblem"
          className="w-full h-full object-contain select-none"
          draggable={false}
        />
      </span>
      <span className="leading-[1.15] text-white">
        <b className="block font-display text-[19px] font-bold tracking-[0.01em]">PSIEC</b>
        {tagline && (
          <span className="block font-body text-[11.5px] font-medium text-[#8FA0B3] mt-0.5">
            Process Safety &amp; Integrity Eng. Consultants
          </span>
        )}
      </span>
    </div>
  );
};
